import Calendar from "@/utils/calendar";

export const  columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '分拣框编号',
        dataIndex: 'basketCode',
        key: 'basketCode',
    },
    {
        title: '分拣框类型',
        dataIndex: 'basketType',
        key: 'basketType',
        customRender: (text, record, index) => {
            return ['发货分拣', '组合分拣','国内发货分拣'][text]
        },
    },
    {
        title: '状态',
        dataIndex: 'useStatus',
        key: 'useStatus',
        customRender: (text, record, index) => {
            return text?'使用中':'未使用'
        },
    },
    {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        ellipsis: true,
        // customRender: (text, record, index) => {
        //     return Calendar.d1(text)
        // },
    },
    {
        title: '创建人',
        dataIndex: 'createrName',
        key: 'createrName',
        ellipsis: true,
    },
    {
        title: '操作',
        key: 'action',
        dataIndex: 'di',
        width: 200,
        scopedSlots: {
            customRender: 'action'
        }
    }
]